const CDN_URL = process.env.REACT_APP_CDN_URL;
const PAGE_PUBLIC = process.env.REACT_APP_PAGE_PUBLIC;
const API_URL = process.env.REACT_APP_API_URL;
const DEBUG = process.env.REACT_APP_DEBUG=='1';
const PLACEHOLDER_IMG = 'https://cdn.arema.dev/assets/evento.png';
const RECAPTCHA = process.env.REACT_APP_RECAPTCHA || null;
const CAPTCHA_ACTIVE = process.env.REACT_APP_CAPTCHA_ACTIVE!='0';

const PAYFRONT_KEY = process.env.REACT_APP_PAYFRONT_KEY;
const OPENPAY_MERCHANT = process.env.REACT_APP_OPENPAY_MERCHANT;
const OPENPAY_KEY = process.env.REACT_APP_OPENPAY_KEY;

export {
	API_URL,
	CAPTCHA_ACTIVE,
	CDN_URL,
	DEBUG,
	OPENPAY_KEY,
	OPENPAY_MERCHANT,
	PAGE_PUBLIC,
	PAYFRONT_KEY,
	PLACEHOLDER_IMG,	
	RECAPTCHA,
}